import React, { useState, useEffect } from 'react';
import { getRol } from '../../../_utils/storage_handler';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Checkbox } from 'antd';
import { 
  findOrdersEvent
} from '../../../_events/orders/find_order.event';
import { aproverOrdersEvent, deleteOrdersEvent, displayPDFOrderEvent,aproverOrdersBNEvent, displayPDFOrderIdEvent } from '../../../_events/orders/order_box.event';
import { message } from 'antd';
import PrimaryProgress from '../../../containers/progress/primary_progress';
import OrdersBoxList from './orders_box_list';
import Chip from '@mui/material/Chip';
import BasicPopconfirm from '../../../containers/popconfirms/basic_popconfirm';
import { isNotViewer } from '../../../_utils/render_actions';
import { viewPDFQrEvent } from '../../../_events/orderDetail/orderDetail.event';
import { specialColors } from '../../../_config/special_colors';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  borderRadius: '20px',
  boxShadow: 24,
  p: 4,
};

const OrdersBox = () => {
  
  const in_process='PEND';

  const [allChecked, setAllChecked] = useState(false);
  
  const [order, setOrder] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openPDF, setOpenPDF] = React.useState(false);
  const [pdf, setPDF] = React.useState(null);
  const [process_state, setProcess_state] = useState([]);

  const handleClosePDF = () => {
    setOpenPDF(false);
    setPDF(null);
  };
  const viewQR =(orderDetail,order_uuid)=>{    
    setOpenPDF(true);
    viewPDFQrEvent(orderDetail,order_uuid)
    .then((data) => {
      setPDF(data.data);
    })
    .catch((error) => {
      console.error(error);
    });
    
  }

  const loadOrders = () => {
    setAllChecked(false);
    setLoading(true);
    findOrdersEvent('PEND')
    .then(data => {
      let orders_list = [];
      let process_list = [];
      let customer_formulas=[];
      let product_weight=[];
      data.list.forEach(obj => {  
        if (obj.uuid != null && obj.id && obj.date_delivery !== null) {  
          orders_list.push(obj);
        } else if(obj.name!=null && obj.cod!=null && obj.cod!='ALIS'  ) {
          process_list.push(obj);
        }else if(obj.id!=null && obj.machine!=null) {
          customer_formulas.push(obj);
        }else if(obj.uuid!=null && obj.kilo!=null) {
          product_weight.push(obj);
        } 
      });
      setOrders(orders_list);
      process_list.sort((a, b) => (a.cod === 'DEFE') ? -1 : ((b.cod === 'DEFE') ? 1 : 0));
      setProcess_state(process_list);
      setLoading(false);
      
    })
    .catch(err => {
      message.error(err.message);
      setLoading(false);
    });
  }

  const setEditOrder = (o, p) => {
    setOrder({uuid: p.uuid, order: o});
  }

  const aproveBN = () => {
    let selectedOptions = []; 
    orders.forEach((order) => {
      let count = 0;
      order.ordersDetail.filter( (od) => specialColors.includes(od.color.cod)).forEach((orderDetail) => {        
        const selectElement = document.querySelector(`select[data-uuid="${orderDetail.uuid}"]`); 
        if (selectElement){
          selectedOptions.push(selectElement.value);
        }else{
          count=1;
        }
      });
      if(count>0){
        selectedOptions.push(`all-defect-i//${order.uuid}`);
        count=0;
      }
    });
    aproverOrdersBNEvent(orders,selectedOptions,in_process)
    .then(data => {
      message.success('Productos B & N enviados a enrollado');
      loadOrders();
    })
    .catch(err => {
      message.error(err.message);
    });
    
    
  };

  const aprove = () => {
    let selectedOptions = []; 
    orders.forEach((order) => {
      let count = 0;
      order.ordersDetail.forEach((orderDetail) => {        
        const selectElement = document.querySelector(`select[data-uuid="${orderDetail.uuid}"]`); 
        if (selectElement){
          selectedOptions.push(selectElement.value);
        }else{
          count=1;
        }
      });
      if(count>0){
        selectedOptions.push(`all-defect-i//${order.uuid}`);
        count=0;
      }
    });
    aproverOrdersEvent(orders,selectedOptions,in_process)
    .then(data => {
      //downloadExcelFile(data.data.toAproveJSON,"ordenes");
      message.success('los productos han sido enviados')
      loadOrders();
    })
    .catch(err => {
      message.error(err.message);
    });
  };
  

  const deleteOrder = (order) => {
    deleteOrdersEvent(order.uuid)
    .then(data => {
      message.success('Orden eliminada');
      loadOrders();
    })
    .catch(err => {
      message.error(err.message);
    });
  }

  const checkAll = () => {
    let check = allChecked;
    let ordersNew = [...orders];
    ordersNew.forEach(element => {
      element.checked = check ? 0 : 1;
    });
    setAllChecked(!check);
    setOrders(ordersNew);
  }

  const displayPDF = (order) => {
    if(! order) message.error('No hay orden');
    else {
      displayPDFOrderIdEvent(order.uuid)
      .then(data => {
        setPDF(data.data.toAproveJSON);
        setOpenPDF(true);     
      })
      .catch(err => {
        message.error(err.message);
      });
    }    
  }

  useEffect(() => {
    loadOrders();
  }, []);

  let rol = getRol();

  return (
    <Grid container spacing={1} >
        <Grid item xs={12} md={12}>
            <Typography variant="h6" component="h6">
                Bandeja de pedidos programados
            </Typography>
            <hr/>
            {
              loading ? (
                <PrimaryProgress />
              ) : (
                <Grid container spacing={1}>
                  <Grid item xs={6} md={6}>
                    <div style={{display: 'flex', flexDirection: 'row', width: '100%'}}>
                      <Chip label={`Total: ${orders.length}`} color="primary" variant="outlined" />
                      <Chip label={`Seleccionadas: ${orders.filter(o => o.checked === 1).length}`} color="success" variant="outlined" />
                    </div>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <div style={{ display: 'flex', flexDirection: 'row-reverse', width: '100%'}}>
                    <div style={{ marginLeft: '20px' }}>
                      <BasicPopconfirm
                        label='Aprobar órdenes'
                        title='¿Desea aprobar las órdenes?'
                        onConfirm={() => { isNotViewer(rol) ? aprove() : alert('Usuario informativo') }}
                      />
                      </div>
                      
                    </div>
                   
                    
                  
                    
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <div style={{width: '100%', display: 'flex', flexDirection: 'row-reverse'}}>
                      <Checkbox
                        style={{marginRight:'55px'}} 
                        checked={allChecked}
                        onClick={event => {
                                event.stopPropagation();
                        }}
                        onChange={() => {
                            checkAll();
                        }}>
                      </Checkbox>
                    </div>                 
                  </Grid>
                  <Grid item xs={12} md={12}>
                        
                    
                    <OrdersBoxList
                      data={orders}
                      process={process_state}
                      viewQR={(orderDetail,order_uuid)=>viewQR(orderDetail,order_uuid)}
                      setEditOrder={(o, p) => setEditOrder(o, p)}
                      updateDataOrdersChecked={(d) => {
                        let index = orders.findIndex(o => o.uuid === d.uuid);
                        if(index === -1){
                          message.error('No se logró seleccionar');
                        } else {
                          let orders_updated = [...orders];
                          orders_updated[index].checked = orders_updated[index].checked === 0 ? 1 : 0;
                          setOrders(orders_updated);
                        }
                      }}
                      
                      deleteOrder = {(o) => {isNotViewer(rol) ? deleteOrder(o) : alert('Usuario informativo')}}
                      displayPDF = {(o) => displayPDF(o)}
                    />
                  </Grid>
                </Grid>
              )
            }
        </Grid>
        <Modal
            open={openPDF}
            onClose={handleClosePDF}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
              <Grid container spacing={1}>
                {
                  !pdf ? <>Cargando...</> :
                  <Grid item xs={12} md={12}>
                    <object width="100%" height="600px" 
                      data={`data:application/pdf;base64,${pdf}`} 
                      type="application/pdf" className="internal"
                    >
                      <embed 
                          src={`data:application/pdf;base64,${pdf}`}
                          type="application/pdf"
                      />
                    </object>
                  </Grid>
                }
              </Grid>
            </Box>
        </Modal>
       
    </Grid>
  );
}

export default OrdersBox;
